module.exports = __webpack_public_path__ + "img/depression.5c99bea1.svg";